module.exports = __webpack_public_path__ + "img/house-008.788744b9.png";